import { Calendar } from "lucide-react";
import { Button } from "../../../components/ui/button";
import { Input } from "../../../components/ui/input";
import { PERIOD_OPTIONS } from "../constants";

/**
 * Barra de período com botões de preset + inputs date quando "custom".
 * Stateless: receba o valor atual e os setters via props.
 */
export function PeriodFilter({ period, setPeriod, from, setFrom, to, setTo }) {
  return (
    <div className="bg-card rounded-2xl border shadow-sm p-4 md:p-5">
      <div className="flex flex-wrap items-center gap-2">
        <div className="flex items-center gap-2 mr-2">
          <Calendar className="w-4 h-4 text-muted-foreground" />
          <span className="text-sm font-medium text-muted-foreground">Período:</span>
        </div>
        {PERIOD_OPTIONS.map((o) => (
          <Button
            key={o.key}
            variant={period === o.key ? "default" : "outline"}
            size="sm"
            onClick={() => setPeriod(o.key)}
          >
            {o.label}
          </Button>
        ))}
      </div>
      {period === "custom" && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4 pt-4 border-t">
          <div>
            <label className="text-sm font-medium mb-1.5 block">Data Início</label>
            <Input type="date" value={from} onChange={(e) => setFrom(e.target.value)} />
          </div>
          <div>
            <label className="text-sm font-medium mb-1.5 block">Data Fim</label>
            <Input type="date" value={to} onChange={(e) => setTo(e.target.value)} />
          </div>
        </div>
      )}
    </div>
  );
}
